import {
  FormFieldWidget,
  FormStringFieldSingleWidget,
  ModelFieldType,
  SPI,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import SpecialPolicyApplication from './SpecialPolicyApplication.vue';
import { queryPromotionType } from '../MindMap/services';
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form, ViewType.Detail],
    ttype: ModelFieldType.String,
    model: ['deli.aries.seller.DeliAriesSellerSpecialApplyOrder','deli.aries.platform.DeliAriesPlatformSpecialApplyOrder'],
    name: 'promotionTypeStr',
    multi: false
  })
)
export class SpecialPolicyApplicationWidget extends FormStringFieldSingleWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(SpecialPolicyApplication);
    return this;
  }

  @Widget.Reactive()
  public baseData: {
    disabled: boolean;
    promotionTypeEnumList: null | { name: string; value: string }[];
  } = {
    promotionTypeEnumList: null,
    disabled: false
  };

  @Widget.Method()
  public submitValue(e) {
    if("ZFD2,ZTJ1,ZFD4,ZFD6".includes(e))
    {
      this.formData.platformDiscount = 100;
      this.formData.provinceDiscount = 0;
      this.formData.productDiscount = 0;
    }
    else{
      this.formData.platformDiscount = 0;
      this.formData.provinceDiscount = 100;
      this.formData.productDiscount = 0;
    }
  };
  protected async mounted() {
    try {
      if (this.viewType === 'DETAIL') {
        this.baseData.disabled = true;
      } else {
        this.baseData.disabled = false;
      }
      super.mounted();
      const res = await queryPromotionType(this.model);
      this.baseData.promotionTypeEnumList = res?.promotionTypeEnumList?.map((item) => {
        return { label: item.displayName, value: item.value };
      });
    } catch (error) {
      console.error(error);
    }
  }
}
